<template>
  <div class="ruKuZuoyeWarp app-container">
    <div class="ruKuZuoyeWarp-body">
      <div>
        <div>
          <div class="detailsTitle">
            <h4>入库计划</h4>
          </div>
          <!-- 查询条件 -->
          <div ref="searchBox" class="formBox margbot" >
            <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData" label-width="100px">
              <div class="formItemBox">
              <el-form-item label="车牌号:">
                <el-input class="ipt" v-model="formData.instockPlateNumber" placeholder="请输入车牌号" size="mini"
                  maxlength="10"></el-input>
              </el-form-item>

              <el-form-item label="一级货主:">
                <el-select v-model="formData.primaryCustomerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
                  <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
                    :value="item.taxpayerNumber">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="二级货主:">
                <el-select v-model="formData.customerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
                  <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
                    :value="item.taxpayerNumber">
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="货权方:">
                <el-select v-model="formData.ownerCustomerTaxId" size="mini" placeholder="请选择货权方" filterable clearable>
                  <el-option v-for="(item1, index1) in HQData" :key="index1" :label="item1.custerName"
                    :value="item1.taxpayerNumber">
                  </el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="创建日期:">
                <div style="display: flex;">
                <el-date-picker v-model="formData.createTimeStart" size="mini" type="date" placeholder="选择创建日期"
                  value-format="yyyy-MM-dd"></el-date-picker>
                -
                <el-date-picker v-model="formData.createTimeEnd" size="mini" placeholder="选择创建日期" type="date"
                  value-format="yyyy-MM-dd"></el-date-picker>
                </div>
              </el-form-item>
              <!-- <el-form-item label="货物类型:">
                <el-select
                  v-model="formData.productType"
                  size="mini"
                  placeholder="请选择货物类型"
                  filterable
                >
                  <el-option
                    v-for="item in HwTypeData"
                    :key="item.item_no"
                    :label="item.show_name"
                    :value="item.item_no"
                  >
                  </el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="司机:">
                <el-input class="ipt" v-model="formData.driverName" placeholder="请输入司机名" size="mini"
                  maxlength="10"></el-input>
              </el-form-item>
              <el-form-item label="到货方式">
                <el-select v-model="formData.arrivalMethod" size="mini" placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="汽运" value="汽运"></el-option>
                  <el-option label="火运" value="火运"></el-option>
                  <el-option label="船运" value="船运"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="入库外部单号:">
                <el-input class="ipt" v-model="formData.inExternalNo" placeholder="请输入入库外部单号" size="mini"
                  maxlength="10"></el-input>
              </el-form-item>
               <el-form-item label="有无货损:">
                <el-select size="mini" v-model="formData.damageflag" placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="有货损" value="1"></el-option>
                  <el-option label="无货损" value="2"></el-option>
                </el-select>
              </el-form-item>
              </div>
              <el-form-item>
                <el-button type="primary" size="mini" @click="xinzeng" btnCode="003P019B001" v-if="btnFlg[0]">新增
                </el-button>
                <el-button type="primary" size="mini" @click="xiugai" btnCode="003P019B003" v-if="btnFlg[1]">修改
                </el-button>
                <el-button type="primary" size="mini" @click="shanchu" btnCode="003P019B002" v-if="btnFlg[2]">删除
                </el-button>
                <el-button type="primary" size="mini" @click="chaxun" btnCode="003P019B004" v-if="btnFlg[3]">查询
                </el-button>
                <el-button type="primary" class="button" size="mini" @click="chongzhi" btnCode="003P019B005"
                  v-if="btnFlg[4]">重置</el-button>
                <!-- <el-button type="primary" size="mini" @click="dayin" btnCode="003P019B006" v-if="btnFlg[5]">打印
                </el-button> -->
                <el-button type="primary" class="button" size="mini" @click="queren" btnCode="003P019B007"
                  v-if="btnFlg[6]">确认入库</el-button>
                <!-- <el-button type="primary" size="mini" @click="dayin1" btnCode="003P019B00F" v-if="btnFlg[11]">打印
                </el-button> -->
                <el-button type="primary" class="button" size="mini" @click="queren1" btnCode="003P019B00E"
                  v-if="btnFlg[10]">确认入库</el-button>
                <!-- 中远2.0版 -->

                <el-button type="primary" class="button" size="mini" @click="querenZhongYuan(1)" btnCode="003P019B00G"
                  v-if="btnFlg[12]">确认入库</el-button>
                <el-button type="primary" class="button" size="mini" @click="querenZhongYuan1" btnCode="003P019B00H"
                  v-if="btnFlg[13]">确认入库</el-button>
                  <!-- 胡鑫库需求确认入库 -->
                <el-button type="primary" class="button" size="mini" @click="querenZhongYuan(2)" btnCode="003M2P0100"
                 v-if="btnFlg[14]">确认入库</el-button>
              </el-form-item>

            </el-form>
          </div>
          <!-- 表格 -->
          <div :style="{ height: h }">
            <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData"
              style="width: 100%" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
              highlight-current-row @row-click="dianjixuanzhong" @selection-change="handleSelectionChange"
              @select="selectXiangqingTable" @select-all="selectAll">
              <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" label="操作" align="center" width="150">
                <template v-slot="scope">
                  <el-button type="text" @click="handleClick(scope.row)">添加货物</el-button>
                  <el-button type="text" @click="huosunFN(scope.row)">货损</el-button>
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="instockNo" label="入库单号" align="center" width="220">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="instockPlateNumber" label="入库车牌号" align="center"
                width="180"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center"
                width="250"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center"
                width="250"></el-table-column>
              <!-- <el-table-column :show-overflow-tooltip="true" prop="ownerCustomerName" label="货权方" align="center"
                width="250"></el-table-column> -->
              <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机姓名" align="center" width="150">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话" align="center" width="150">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机身份证号" align="center" width="200">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="arrivalMethod" label="到货方式" align="center" width="200">
                <!-- <template scope="scope">{{['', "汽运", "火运", "船运"][scope.row.arrivalMethod]}}</template> -->
                <template scope="scope">
                  {{ scope.row.arrivalMethod == 1 ? '汽运' : scope.row.arrivalMethod == 2 ? '火运' : scope.row.arrivalMethod
                    == 3 ? '船运' : scope.row.arrivalMethod }}
                </template>

              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="inExternalNo" label="入库外部单号" align="center" width="200">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" align="center" width="200">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" align="center"
                :formatter="dateTimeFormat" width="180"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="ext1" label="有无货损" align="center">
                <template v-slot="scope">
                  <div>
                    <el-button type="text" v-if="scope.row.ext2==1" size="small" @click="ckhsFN(scope.row)">有</el-button>
                    <span v-else>无</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" width="180" prop="ext1" label="备注" align="center">
              </el-table-column>
            </el-table>
          </div>
          <div class="pags" style="text-align: right">
            <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo"
              :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
              layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total">
            </el-pagination>
          </div>
          <div class="market_out">
            <div class="detailsTitle">
              <h4>货物详情</h4>
            </div>
            <!--货物详情-->
            <div>
              <div>
                <!-- <el-button
                  type="primary"
                  size="mini"
                  @click="xiugaidown"
                  btnCode="003P01AB001"
                  v-if="btnFlg[1]"
                  >修改</el-button> -->

                <!-- <el-button
                  type="primary"
                  size="mini"
                  @click="addJz"
                  btnCode="003P01AB001"
                  v-if="btnFlg[5]"
                  >添加净重</el-button>
                <el-button
                  type="primary"
                  class="button"
                  size="mini"
                  @click="xgJz"
                  btnCode="003P01AB003"
                  v-if="btnFlg[6]"
                  >修改净重</el-button> -->
              </div>
              <div ref="searchBox2" style="margin-top: 5px;margin-bottom:5px;margin-left:10px;">
                <el-button type="primary" size="mini" @click="shanchuXQ" btnCode="003P019B009" v-if="btnFlg[7]">删除
                </el-button>
                <el-button type="primary" size="mini" @click="xc" btnCode="003P019B00A" v-if="btnFlg[8]">卸车确认
                </el-button>
                <span>
                  总吨数:
                  <span style="color: red">{{ totalAllWeight }}</span> &nbsp;吨
                </span>
                <span style="margin-left: 15px">
                  总件数:
                  <span style="color: red">{{ totalNumber }}</span> &nbsp;件
                </span>
              </div>
              <!--详情表格-->
              <div class="ruKuZuoyeWarp-body-detailsTab">
                <div class="ruKuZuoyeWarp-body-table" :style="{ height: detailsH }">
                  <el-table height="100%" size="mini" ref="tabref" :data="detailsData" style="width: 100%"
                    :header-cell-style="{
                      background: '#F5F5F5',
                      color: 'black',
                    }" highlight-current-row @row-click="dianjixuanzhongXQ" border center bordersize="mini">
                    <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center"
                      width="100"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center"
                      width="250"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"
                      width="150"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center" width="150">
                    </el-table-column>
                    <!-- <el-table-column
                      :show-overflow-tooltip="true"
                      prop="length"
                      label="长度"
                      align="center"
                      width="150"
                    ></el-table-column> -->
                    <!-- <el-table-column
                      :show-overflow-tooltip="true"
                      prop="root"
                      label="单件支数"
                      align="center"
                      width="150"
                    ></el-table-column> -->
                    <el-table-column :show-overflow-tooltip="true" prop="singletonWeight" label="单件理重（吨）" align="center"
                      width="150">
                      <template slot-scope="scope">
                        <div>
                          <span v-if="scope.row.singletonWeight == undefined || scope.row.singletonWeight == ''"></span>
                          <span v-else>{{ Number(scope.row.singletonWeight).toFixed(3) }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center" width="120">
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" align="center"
                      width="120">
                      <template slot-scope="scope">
                        <div>
                          <span v-if="scope.row.allWeight == undefined || scope.row.allWeight == ''"></span>
                          <span v-else>{{ Number(scope.row.allWeight).toFixed(3) }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重(吨)" align="center" width="120">
                      <template slot-scope="scope">
                        <div>
                          <span v-if="scope.row.weight == undefined || scope.row.weight == ''"></span>
                          <span v-else>{{ Number(scope.row.weight).toFixed(3) }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="factoryWeight" label="出厂过磅净重（吨）" align="center"
                      width="150">
                      <template slot-scope="scope">
                        <div>
                          <span v-if="scope.row.factoryWeight == undefined || scope.row.factoryWeight == ''"></span>
                          <span v-else>{{ Number(scope.row.factoryWeight).toFixed(3) }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="weighingWeight" label="过磅净重（吨）" align="center"
                      width="150">
                      <template slot-scope="scope">
                        <div>
                          <span v-if="scope.row.weighingWeight == undefined || scope.row.weighingWeight == ''"></span>
                          <span v-else>{{ Number(scope.row.weighingWeight).toFixed(3) }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" :formatter="dateTimeFormat" property="weighingDate"
                      label="实际过磅时间" align="center" width="180"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" width="130"
                      align="center"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="locationName" label="区位" width="130"
                      align="center"></el-table-column>
                    <!--  <el-table-column :show-overflow-tooltip="true" prop="binName" label="货位" width="130" align="center">
                    </el-table-column> -->
                    <el-table-column :show-overflow-tooltip="true" prop="sceneUser" label="现场人员" width="200"
                      align="center"></el-table-column>
                  </el-table>
                </div>
                <!--分页-->
                <div class="pags" style="text-align: right">
                  <el-pagination background @current-change="handleCurrentChangeXQ" :current-page="pageInfoXQ.pageNo"
                    :page-size="pageInfoXQ.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
                    layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeXQ" :total="totalXQ">
                  </el-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- dialogs -->
    <!-- 卸车确认 -->
    <div class="xieche">
      <el-dialog title="卸车确认" :visible.sync="xiecheVisible" :close-on-click-modal="false" width="50%" center
        @close="closeaddXc">
        <el-form :model="xcFormData" ref="xcFormData" label-width="200px" class="demo-dynamic"
          style="width: 500px; margin: 30px auto" :rules="xiecheRules">
          <el-form-item prop="number" label="实入件数">
            <el-input v-number-input.float="0" v-model="xcFormData.number" placeholder="请输入实入件数" size="mini"
              style="width: 200px" type="number" @blur="xcNumberInput"></el-input>
          </el-form-item>
          <el-form-item prop="weight" label="理重（吨）">
            <el-input v-model="xcFormData.weight" placeholder="请输入理重" size="mini" style="width: 200px" type="number"
              :disabled="true"></el-input>
          </el-form-item>
          <el-form-item prop="warehouseId" label="仓库">
            <el-select v-model="xcFormData.warehouseId" size="mini" placeholder="请选择仓库名" style="width: 200px"
              @change="selectWarehouse(xcFormData.warehouseId)">
              <el-option v-for="item in ckData" :key="item.warehouseId" :label="item.warehouseName"
                :value="item.warehouseId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="locationId" label="区位">
            <el-select v-model="xcFormData.locationId" size="mini" placeholder="请选择区位" style="width: 200px"
             @change="selectLocation">
              <el-option v-for="item in qwData" :key="item.locationId" :label="item.locationName"
                :value="item.locationId"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item
              prop="binId"
              label="货位"
            >
              <el-select
                v-model="xcFormData.binId"
                size="mini"
                placeholder="请选择货位"
              :disabled='disBin'
                style="width: 200px"
              >
                <el-option
                v-for="item in hwData"
                :key="item.binId"
                :label="item.binName"
                :value="item.binId"
                ></el-option>
              </el-select>
            </el-form-item> -->
          <el-form-item prop="sceneUserId" label="现场人员">
            <el-select v-model="xcFormData.sceneUserId" size="mini" filterable placeholder="请选择现场人员" style="width: 200px">
              <el-option v-for="item in ryData" :key="item.id" :label="item.userName" :value="item.userCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="weighingWeight" label="入库过磅净重（吨）">
            <el-input v-model="xcFormData.weighingWeight" v-number-input.float="3" size="mini" placeholder="请输入入库过磅净重"
              style="width: 200px"></el-input>
          </el-form-item>
          <!-- <el-form-item
              prop="weighingDate"
              label="实际过磅时间"
            >
              <el-date-picker
                  v-model="xcFormData.weighingDate"
                  size="mini"
                  type="datetime"
                  placeholder="选择过磅日期"
                  style="width: 200px"
                ></el-date-picker>
            </el-form-item> -->
        </el-form>
        <div slot="footer" style="width: 180px; margin: 15px auto">
          <el-button @click="closeaddXc">取 消</el-button>
          <el-button type="primary" :loading="xcLoading" @click="addXcDialog">保 存</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 新增入库指令 -->
    <div class="xinzeng">
      <el-drawer direction="ltr" :title="RkzlTitle" :wrapperClosable="false" :visible.sync="addRKVisible" size="550px"
        @close='closeXz'>
        <el-form :model="xzFormData" ref="xzFormData" label-width="200px" class="demo-dynamic"
          style="width: 500px; margin: 30px auto">
          <el-form-item prop="instockPlateNumber" label="入库车牌号" :rules="[
            {
              required: true,
              message: '请输入车牌号',
              trigger: 'blur',
            }
          ]">
            <el-input v-model="xzFormData.instockPlateNumber" size="mini" style="width: 200px" placeholder="请输入入库车牌号"
              type="text" :maxlength="20"></el-input>
          </el-form-item>
          <el-form-item prop="driverName" label="司机姓名" :rules="[
            {
              required: false,
              message: '请输入司机姓名',
              trigger: 'change',
            }
          ]">
            <el-input v-model="xzFormData.driverName" size="mini" style="width: 200px" placeholder="请输入司机姓名"
              type="text"></el-input>
            <el-button style="margin-left:10px;" type="text" @click="selectDriverChange">选择</el-button>
          </el-form-item>
          <el-form-item prop="telephone" label="司机电话" :rules="[
            {
              required: false,
              message: '请输入司机电话',
              trigger: 'blur',
            }
          ]">
            <el-input v-model="xzFormData.telephone" size="mini" style="width: 200px" v-number-input.float="0"
              placeholder="请输入司机电话" :maxlength="11"></el-input>
          </el-form-item>
          <el-form-item prop="idNumber" label="司机身份证号" :rules="[
            {
              required: false,
              message: '请输入司机身份证号',
              trigger: 'blur',
            }
          ]">
            <el-input v-model="xzFormData.idNumber" size="mini" style="width: 200px" placeholder="请输入司机身份证号" type="text"
              maxlength="18"></el-input>
          </el-form-item>
          <!-- <el-form-item prop="ownerCustomerTaxId" label="货权方">
            <el-select v-model="xzFormData.ownerCustomerTaxId" size="mini" placeholder="请选择货权方" style="width: 200px"
              filterable clearable>
              <el-option v-for="(item, index) in xzData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber"></el-option>
            </el-select>
          </el-form-item>  -->
          <el-form-item prop="primaryCustomerTaxId" label="一级货主" :rules="[
            {
              required: true,
              message: '请选择一级货主',
              trigger: 'change',
            }
          ]">
            <el-select v-model="xzFormData.primaryCustomerTaxId" size="mini" placeholder="请选择货主" style="width: 200px"
              filterable @change="yjhzChange">
              <el-option v-for="(item, index) in xzData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="customerTaxId" label="二级货主" :rules="[
            {
              required: true,
              message: '请选择二级货主',
              trigger: 'change',
            }
          ]">
            <el-select v-model="xzFormData.customerTaxId" size="mini" placeholder="请选择货主" style="width: 200px" filterable>
              <el-option v-for="(item, index) in xzData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="arrivalMethod" label="到货方式" :rules="[
            {
              required: true,
              message: '请选择到货方式',
              trigger: 'change',
            }
          ]">
            <el-select v-model="xzFormData.arrivalMethod" size="mini" placeholder="请选择">
              <el-option label="汽运" value="汽运"></el-option>
              <el-option label="火运" value="火运"></el-option>
              <el-option label="船运" value="船运"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="inExternalNo" label="入库外部单号" :rules="[
            {
              required: RKWBDHflag,
              message: '入库外部单号',
              trigger: 'blur',
            }
          ]">
            <el-input v-model="xzFormData.inExternalNo" size="mini" style="width: 200px" placeholder="请输入入库外部单号"
              type="text" :maxlength="20"></el-input>
          </el-form-item>
          <el-form-item prop="ext1" label="备注">
            <el-input v-model="xzFormData.ext1" size="mini" style="width:200px;" placeholder="请输入备注" maxlength="100"
              type="textarea"></el-input>
          </el-form-item>
        </el-form>
        <div style="width:180px; margin:15px auto">
          <el-button @click="closeXz">取 消</el-button>
          <el-button type="primary" @click="addXzDialog" :loading="JZLoading">保 存</el-button>
        </div>
      </el-drawer>
      <select-siji v-if="table" :table.sync="table" @selectDriver="selectDriver"></select-siji>

    </div>

    <!-- 添加货物 -->
    <div class="addHuowu">
      <el-dialog :title="xzTitle" :visible.sync="addHuowuVisible" :close-on-click-modal="false" width="50%"
        @close="closeaddHw" center>
        <el-form :model="hwFormData" ref="hwFormData" label-width="200px" class="demo-dynamic"
          style="width: 500px; margin: 30px auto">
          <el-form-item prop="productType" label="货物类型" :rules="[
            {
              required: true,
              message: '请选择货物类型',
              trigger: 'change',
            },
          ]">
            <el-select v-model="hwFormData.productType" size="mini" placeholder="请选择" @change="selectProductType"
              style="width: 200px">
              <el-option v-for="(item, index) in productTypeOptions" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="steelMillName" label="产地" :rules="[
            {
              required: true,
              message: '请选择产地',
              trigger: 'change',
            },
          ]">
            <el-select v-model="hwFormData.steelMillName" size="mini" placeholder="请选择产地" :disabled='disChandi'
              @change="selectChandi" style="width: 200px">
              <el-option v-for="(item, index) in chanDiOptions" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="specification" label="规格" :rules="[
            {
              required: true,
              message: '请选择规格',
              trigger: 'change',
            },
          ]">
            <el-select v-model="hwFormData.specification" size="mini" placeholder="请选择规格" :disabled='disGuige'
              style="width: 200px" @change="selectGuige" filterable>
              <el-option v-for="(item, index) in guigeOptions" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="model" label="材质" :rules="[
            {
              required: true,
              message: '请选择材质',
              trigger: 'change',
            },
          ]">
            <el-select v-model="hwFormData.model" size="mini" placeholder="请选择材质" :disabled="disCaizhi"
              @change="selectCaizhi()" style="width: 200px">
              <el-option str :class="{ 'redColor': item.includes('500') }" v-for="(item, index) in caizhiOptions"
                :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item
              prop="length"
              label="长度"
              v-if="showLwg"
              :rules="[
                {
                  required: true,
                  message: '请选择长度',
                  trigger: 'change',
                },
              ]"
            >
              <el-select
                v-model="hwFormData.length"
                size="mini"
                placeholder="请选择长度"
                :disabled="dislength"
                style="width: 200px"
                @change="selectchangdu"
              >
                <el-option
                  v-for="(item,index) in changDuOptions"
                  :key="index"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item> -->
          <!-- <el-form-item
              v-if="showLwg"
              prop="root"
              label="单件支数"
              :rules="[
                {
                  required: true,
                  message: '请选择单件支数',
                  trigger: 'change',
                },
              ]"
            >
              <el-select
                v-model="hwFormData.root"
                size="mini"
                placeholder="请选择单件支数"
                :disabled="disDanzhi"
                style="width: 200px"
              >
              <el-option
                v-for="(item,index) in rootOptions"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
              </el-select>
            </el-form-item> -->
          <el-form-item prop="singletonWeight" label="单件理重（吨）" :rules="[
            {
              required: true,
              message: '请先维护本物料单件理重',
              trigger: 'blur',
            },
          ]">
            <el-input v-model="hwFormData.singletonWeight" size="mini" style="width: 200px" type="number" :disabled='true'
              placeholder="请选择单理重"></el-input>
          </el-form-item>
          <el-form-item prop="number" label="件数" :rules="[
            {
              required: true,
              message: '请输入件数',
              trigger: 'blur',
            },
            {
              validator: validateInt,
              message: '件数不能为0',
              trigger: 'blur'
            }
          ]">
            <el-input v-model="hwFormData.number" size="mini" style="width: 200px" type="number" v-number-input.float="0"
              :min="1" :disabled='disJianshu' @blur="NumberInput" placeholder="请输入件数">
            </el-input>
          </el-form-item>
          <el-form-item prop="weight" label="理重（吨）" :rules="[
            {
              required: true,
              message: '请先维护本物料单件理重',
              trigger: 'blur',
            },
          ]">
            <el-input v-model="hwFormData.weight" size="mini" style="width: 200px" :disabled='true' placeholder="请输入理重"
              type="number"></el-input>
          </el-form-item>
          <el-form-item prop="factoryWeight" label="出厂过磅净重（吨）" :rules="[
            {
              required: true,
              message: '请输入出厂过磅净重（吨）',
              trigger: 'blur',
            },
          ]">
            <el-input v-model="hwFormData.factoryWeight" v-number-input.float="3" size="mini" :min="0"
              style="width: 200px" placeholder="请输入出厂过磅净重"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="closeaddHw">取 消</el-button>
          <el-button type="primary" :loading="addHwLoading" @click="addHwDialog">保 存</el-button>
          <el-button type="primary" v-if="showSave" :loading="saveaddHwLoading" @click="saveaddHwDialog">保存并添加
          </el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 确认入库 -->
    <div>
      <el-dialog title="确认入库" :visible.sync="querenrukuVisible" :close-on-click-modal="false" width="50%"
        @close="closeQuerenruku" center>
        <el-form label-position="left" ref="querenrukuFormData" label-width="100px"
          style="width: 500px; margin: 30px auto" :model='querenRukuForm'>
          <el-form-item label="车牌号:" :rules="[
            {
              required: true,
              message: '请先维护本物料单件理重',
              trigger: 'blur',
            },
          ]">
            <span style="width: 200px">{{ querenRukuForm.plateNumber }}</span>
            <!-- <el-input
                v-model="hwFormData.singletonWeight"
                size="mini"
                style="width: 200px"
                type="number"
                :disabled='true'
                placeholder="请选择单理重"
              ></el-input> -->
          </el-form-item>
          <el-form-item prop="xiecheCost" label="卸车费(元):" :rules="[
            {
              required: true,
              message: '请输入卸车费',
              trigger: 'blur',
            },
          ]">
            <el-input v-number-input.float="2" v-model="querenRukuForm.xiecheCost" size="mini" style="width: 200px"
               placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="closeQuerenruku">取 消</el-button>
          <el-button type="primary" :loading="querenLoading" @click="querenRukuOk">保 存</el-button>
        </div>
      </el-dialog>
      <el-dialog title="查看备注" :visible.sync="dialogBeizhuVisible" width="35%">
        <div v-if="!lookApproverReject">{{ beizhu }}</div>
        <span v-if="lookApproverReject">暂无备注</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogBeizhuVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 货损上传 -->
    <huosunshangchuan  v-if="HSSCflag" :HSSCflag.sync="HSSCflag" :rowData="rowData"></huosunshangchuan>
     <!-- 查看货损 -->
    <chakanhuosun  v-if="CKHSflag" :CKHSflag.sync="CKHSflag" :rowData="rowData"></chakanhuosun>
  </div>
</template>

<script>
import {
  getThreadMasterList,
  addOrUpdateThreadMaster,
  addOrUpdateThreadProduct,
  zidianKuwei,
  zidianQuwei,
  zidianHuowei,
  deleteThreadMaster,
  confirmThreadStorage,
  getThreadSummaryList,
  deleteThreadProduct,
  confirmThreadCw,
  getThreadSummaryTotalWN,
  confirmThreadCwDjc,
  findCustomerList
} from '@/api/wms-access'
import {
  getRelationCustomer,
  getUsersByTenantCode,
  getVirtualBalingList,
  zidian,
  getWeighingMethodList
  // getDictionaryList
} from '@/api/wms-stock'
import {
  dateTimeFormat
} from '@/utils/util'

import {
  getBtn
} from '@/utils/getButton'
import SelectSiji from '../SelectSiji'
import DonMessage from '@/utils/message'
import huosunshangchuan from '@/views/wms-access/lwgruku/huosunshangchuan.vue'
import chakanhuosun from '@/views/wms-access/lwgruku/chakanhuosun.vue'

var validateInt = (rule, value, callback) => {
  if (value == 0) {
    callback(new Error('件数不能为0'))
  } else {
    callback()
  }
}
export default {
  components: {
    SelectSiji, huosunshangchuan, chakanhuosun
  },
  data () {
    return {
      validateInt: validateInt,
      dateTimeFormat: dateTimeFormat, // 列表时间格式化

      formData: {
        instockPlateNumber: '',
        primaryCustomerName: '',
        customerName: '',
        createTimeStart: '',
        createTimeEnd: '',
        // productType: '',
        driverName: '',
        customerTaxId: '',
        primaryCustomerTaxId: '',
        ownerCustomerTaxId: '' // 货权方

      },
      HwTypeData: [],
      totalXQ: 0,
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      pageInfoXQ: {
        pageSize: 20,
        pageNo: 1
      },
      total: 0,
      detailsData: [], // 详情数据
      RKData: [],
      HQData: [], // 货权方
      btnFlg: [],
      tableData: [],
      totalAllWeight: '',
      totalNumber: '',
      HWXiangQingLook: true,
      activeName: 'first',
      btnIdArr: [
        '003P019B001',
        '003P019B003',
        '003P019B002',
        '003P019B004',
        '003P019B005',
        '003P019B006',
        '003P019B007',
        '003P019B009',
        '003P019B00A',
        '003P019B00C',
        '003P019B00E',
        '003P019B00F',
        '003P019B00G',
        '003P019B00H',
        '003M2P0100'
      ],
      detailsH: '200px',
      h: '500px',
      addJingzhongVisible: false,
      addFormData: {
        guobang: '',
        shijan: ''
      },
      xiecheVisible: false,
      xcFormData: {
        number: '',
        weight: '',
        warehouseId: '',
        locationId: '',
        binId: '',
        sceneUserId: '',
        weighingWeight: '',
        weighingDate: '',
        huoQuanFang: '' // 货权方
      },
      ckData: [],
      qwData: [],
      hwData: [],
      ryData: [],
      addHuowuVisible: false,
      hwFormData: {
        steelMillName: '',
        model: '',
        specification: '',
        // length: '',
        // root: '',
        singletonWeight: '',
        number: '',
        weight: '',
        factoryWeight: '',
        productType: ''
      },
      addHwLoading: false,
      saveaddHwLoading: false,
      addRKVisible: false,

      table: false,
      xzFormData: {
        instockPlateNumber: '',
        driverName: '',
        telephone: '',
        idNumber: '',
        arrivalMethod: '',
        primaryCustomerName: '',
        ownerCustomerTaxId: '',
        ownerCustomerName: '',
        customerName: '',
        productTypeName: '',
        ext1: ''
      },
      xiecheRules: {
        warehouseId: [{
          required: true,
          message: '请选择仓库',
          trigger: 'change'
        }],
        number: [{
          required: true,
          message: '请输入实入件数',
          trigger: 'blur'
        }],
        locationId: [{
          required: true,
          message: '请选择区位',
          trigger: 'change'
        }],
        binId: [{
          required: true,
          message: '请选择货位',
          trigger: 'change'
        }],
        sceneUserId: [{
          required: true,
          message: '请选择现场人员',
          trigger: 'change'
        }],
        weighingWeight: [{
          required: true,
          message: '请输入入库过磅净重',
          trigger: 'blur'
        }],
        weighingDate: [{
          required: true,
          message: '请选择实际过磅时间',
          trigger: 'change'
        }]
      },
      xzData: [],
      RkzlTitle: '',
      JZLoading: false,
      xuanzhongArr: null,
      xuanzhongArrXQ: null,
      xzTitle: '添加货物',
      productTypeOptions: [],
      chanDiOptions: [],
      caizhiOptions: [],
      guigeOptions: [],
      changDuOptions: [],
      rootOptions: [],
      showLwg: true,
      disChandi: true,
      disGuige: true,
      disCaizhi: true,
      dislength: true,
      disDanzhi: true,
      disJianshu: true,
      selectObj: {
        productType: '',
        steelMillName: '',
        placeOfOrigin: '',
        specification: '',
        model: ''
        // length: ''
      },
      xcLoading: false,
      showSave: true,
      messages: '',
      inWeighingMethod: '',
      querenrukuVisible: false,
      querenRukuForm: {
        xiecheCost: '',
        plateNumber: ''
      },
      querenLoading: false,
      disLocation: true,
      disBin: true,
      beizhu: '',
      dialogBeizhuVisible: false,
      lookApproverReject: false,
      querenFlag: 0,
      isNanTouXiku: '',
      RKWBDHflag: false,
      HSSCflag: false,
      rowData: {},
      CKHSflag: false
      // 2.0
      // querenmark:false,
    }
  },
  methods: {
    // 查看货损
    ckhsFN (row) {
      this.CKHSflag = true
      this.rowData = row
    },
    // 货损
    huosunFN (row) {
      this.rowData = row
      this.HSSCflag = true
    },
    // 一级货主改变
    yjhzChange (e) {
      let name = this.xzData.filter(item => item.taxpayerNumber == e)[0].custerName
      // 全部必填不用判断了20250225， 后因五矿 改成相反的判断
      findCustomerList({ customerName: name }).then(res => {
        if (res.length > 0) {
          this.RKWBDHflag = false
        } else {
          this.RKWBDHflag = true
        }
      })
      console.log(this.RKWBDHflag)
    },
    // 确认入库中远2.0版
    querenZhongYuan (n) { // 2为念头西裤20240118
      if (this.tableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      this.isNanTouXiku = n
      this.querenrukuVisible = true
      this.querenLoading = false

      this.querenRukuForm.plateNumber = ''
      this.querenRukuForm.xiecheCost = ''
      this.$nextTick(() => {
        this.$refs.querenrukuFormData.clearValidate()
      })
      this.querenFlag = 1
      this.querenRukuForm.plateNumber = this.xuanzhongArr.instockPlateNumber
    },
    chakanbeizhu (row) {
      this.dialogBeizhuVisible = true
      this.beizhu = row.ext1
    },
    // 确认入库
    querenRukuOk () {
      console.log(this.querenRukuForm.xiecheCost, this.querenRukuForm.plateNumber)
      if (this.isNanTouXiku == 1) {
        this.$refs.querenrukuFormData.validate((valid) => {
          if (valid) {
            this.querenLoading = true
            // 等于1时--中远
            if (this.querenFlag == 1) {
              confirmThreadCw({
                instockId: this.xuanzhongArr.instockId,
                unloadingCharge: this.querenRukuForm.xiecheCost

              })
                .then(res => {
                  DonMessage.success('操作成功!')
                  this.querenrukuVisible = false
                  this.getThreadMasterLists()
                })
                .catch(err => {
                  this.querenLoading = false
                  this.$message.error(err.message)
                })
            } else {
              confirmThreadStorage({
                instockId: this.xuanzhongArr.instockId,
                unloadingCharge: this.querenRukuForm.xiecheCost
              })
                .then(res => {
                  DonMessage.success('操作成功!')

                  this.querenrukuVisible = false
                  this.getThreadMasterLists()
                })
                .catch(err => {
                  this.querenLoading = false
                  this.$message.error(err.message)
                })
            }
          } else {
            this.querenLoading = false
          }
        })
      } else if (this.isNanTouXiku == 2) {
        this.$refs.querenrukuFormData.validate((valid) => {
          if (valid) {
            this.querenLoading = true
            confirmThreadCwDjc({
              instockId: this.xuanzhongArr.instockId,
              unloadingCharge: this.querenRukuForm.xiecheCost

            })
              .then(res => {
                DonMessage.success('操作成功!')
                this.querenrukuVisible = false
                this.getThreadMasterLists()
              })
              .catch(err => {
                this.querenLoading = false
                this.$message.error(err.message)
              })
          } else {
            this.querenLoading = false
          }
        })
      }
    },
    closeQuerenruku () {
      this.querenrukuVisible = false
    },
    // 总重量
    getThreadSummaryTotalWNs () {
      getThreadSummaryTotalWN({
        instockId: this.xuanzhongArr.instockId
      })
        .then(res => {
          console.log(res)
          this.totalAllWeight = res.totalAllWeight
          this.totalNumber = res.totalNumber
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    selectProductType () {
      // if (this.hwFormData.productType == '4' || this.hwFormData.productType == '7') {
      //   // this.xzTitle = '添加货物(螺纹钢)'
      //   this.showLwg = true
      // } else if (this.hwFormData.productType == '5' || this.hwFormData.productType == '6') {
      //   // this.xzTitle = '添加货物(盘螺、高线)'
      //   this.showLwg = false
      // }
      this.disChandi = false
      this.disGuige = true
      this.disCaizhi = true
      this.dislength = true
      this.disDanzhi = true
      this.disJianshu = true
      this.selectObj.productType = this.hwFormData.productType
      this.selectObj.steelMillName = ''
      this.selectObj.placeOfOrigin = ''
      this.selectObj.specification = ''
      this.selectObj.model = ''

      this.hwFormData.placeOfOrigin = ''
      this.hwFormData.steelMillName = ''
      this.hwFormData.model = ''
      this.hwFormData.specification = ''
      // this.hwFormData.length = ''
      this.hwFormData.singletonWeight = ''
      this.hwFormData.number = ''
      this.hwFormData.weight = ''
      // this.hwFormData.root = ''
      this.chanDiOptions = []
      this.guigeOptions = []
      this.caizhiOptions = []

      getWeighingMethodList({
        productType: this.hwFormData.productType
      })
        .then(res => {
          console.log(res)
          if (res.length > 0) {
            this.inWeighingMethod = res[0].inWeighingMethod
            getVirtualBalingList(
              this.selectObj
            )
              .then(res => {
                console.log(res)
                this.chanDiOptions = Array.from(new Set(res.map(item => item.placeOfOrigin)))
              })
              .catch(err => {
                DonMessage.error(err)
              })
          } else {
            DonMessage.error('计重方式未配置，请联系管理员')
          }
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    selectChandi () {
      this.disGuige = false
      this.disCaizhi = true
      this.dislength = true
      this.disDanzhi = true
      this.disJianshu = true
      this.selectObj.steelMillName = this.hwFormData.steelMillName
      this.selectObj.placeOfOrigin = this.hwFormData.steelMillName
      this.selectObj.specification = ''
      this.selectObj.model = ''

      this.hwFormData.model = ''
      this.hwFormData.specification = ''
      // this.hwFormData.length = ''
      this.hwFormData.singletonWeight = ''
      this.hwFormData.number = ''
      this.hwFormData.weight = ''
      // this.hwFormData.root = ''
      this.guigeOptions = []
      this.caizhiOptions = []
      getVirtualBalingList(
        this.selectObj
      )
        .then(res => {
          console.log(res)
          this.guigeOptions = Array.from(new Set(res.map(item => item.specification)))
        })
        .catch(err => {
          DonMessage.error(err)
        })
    },
    selectGuige () {
      this.disCaizhi = false
      this.dislength = true
      this.disDanzhi = true
      this.disJianshu = true
      this.selectObj.specification = this.hwFormData.specification
      // this.getVirtualBalingLists()
      // this.selectObj.steelMillName = ''
      // this.selectObj.specification = ''
      this.selectObj.model = ''

      this.hwFormData.model = ''
      this.hwFormData.number = ''

      // this.hwFormData.specification = ''
      // this.hwFormData.length = ''
      // this.hwFormData.root = ''
      this.hwFormData.singletonWeight = ''
      this.hwFormData.weight = ''
      this.caizhiOptions = []

      getVirtualBalingList(
        this.selectObj
      )
        .then(res => {
          this.caizhiOptions = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(err => {
          DonMessage.error(err)
        })
    },
    selectCaizhi () {
      this.dislength = false
      // this.disDanzhi = false
      this.selectObj.model = this.hwFormData.model
      this.hwFormData.singletonWeight = ''
      this.hwFormData.number = ''
      this.hwFormData.weight = ''
      // this.hwFormData.root = ''
      getVirtualBalingList(
        this.selectObj
      )
        .then(res => {
          this.hwFormData.singletonWeight = res[0].weight
          this.disJianshu = false
        })
        .catch(err => {
          DonMessage.error(err)
        })
    },
    // selectchangdu () {
    //   this.disDanzhi = false

    //   // this.selectObj.model = this.hwFormData.model
    //   // this.selectObj.length = this.hwFormData.length
    //   this.hwFormData.singletonWeight = ''
    //   this.hwFormData.root = ''
    //   getVirtualBalingList(
    //     this.selectObj
    //   )
    //     .then(res => {
    //       console.log(res)
    //       this.changDuOptions = Array.from(new Set(res.map(item => item.length)))
    //       this.rootOptions = Array.from(new Set(res.map(item => item.root)))
    //       this.hwFormData.singletonWeight = res[0].weight
    //     })
    //     .catch(err => {
    //       DonMessage.error(err)
    //     })
    // },
    NumberInput () {
      this.hwFormData.weight = (this.hwFormData.number / 1 * this.hwFormData.singletonWeight).toFixed(3)
    },
    getVirtualBalingLists () {
      getVirtualBalingList(
        this.selectObj
      )
        .then(res => {
          console.log(res)
          // this.chanDiOptions = Array.from(new Set(res.map(item => item.placeOfOrigin)))

          let productArr = []
          res.forEach(item => {
            let obj = {}
            obj.id = item.productType
            obj.name = item.productTypeName
            productArr.push(obj)
          })
          const ress = new Map()
          let arrNew = productArr.filter((arr) => !ress.has(arr.id) && ress.set(arr.id, 1))
          this.productTypeOptions = arrNew
        })
        .catch(err => {
          DonMessage.error(err)
        })
    },
    // 添加货物
    handleClick (row) {
      // this.getWeighingMethodLists(this.xuanzhongArr.productType)
      this.addHuowuVisible = true
      this.addHwLoading = false
      this.saveaddHwLoading = false
      this.showSave = true
      this.$nextTick(() => {
        this.$refs.hwFormData.clearValidate()
      })
      this.initaddHw()

      this.hwFormData.instockId = row.instockId
      // this.hwFormData.productType = row.productType
      // this.selectObj.productType = row.productType
      this.getVirtualBalingLists()
    },
    dianjixuanzhong (row) {
      // console.log(row)
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
      this.getThreadSummaryLists()
    },
    xinzeng () {
      this.addRKVisible = true
      this.JZLoading = false

      this.RkzlTitle = '新增入库指令'
      this.messages = '新增成功'
      this.$nextTick(() => {
        this.$refs.xzFormData.clearValidate()
      })
      this.initForm()
      // this.getDictionaryLists()
      this.getRelationCustomerS()
      this.zidians()
    },
    xiugai () {
      if (this.tableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      this.addRKVisible = true
      this.JZLoading = false
      this.$nextTick(() => {
        this.$refs.xzFormData.clearValidate()
      })
      this.RkzlTitle = '修改入库指令'
      this.messages = '修改成功'
      console.log(this.xuanzhongArr, ' this.xuanzhongArr')
      this.$set(this.xzFormData, 'instockPlateNumber', this.xuanzhongArr.instockPlateNumber)
      this.$set(this.xzFormData, 'driverName', this.xuanzhongArr.driverName)
      this.$set(this.xzFormData, 'telephone', this.xuanzhongArr.telephone)
      this.$set(this.xzFormData, 'idNumber', this.xuanzhongArr.idNumber)
      this.$set(this.xzFormData, 'ownerCustomerTaxId', this.xuanzhongArr.ownerCustomerTaxId)
      this.$set(this.xzFormData, 'primaryCustomerTaxId', this.xuanzhongArr.primaryCustomerTaxId)
      this.$set(this.xzFormData, 'customerTaxId', this.xuanzhongArr.customerTaxId)
      // this.$set(this.xzFormData, 'productType', this.xuanzhongArr.productType)
      this.$set(this.xzFormData, 'instockId', this.xuanzhongArr.instockId)
      this.$set(this.xzFormData, 'ext1', this.xuanzhongArr.ext1)
      this.$set(this.xzFormData, 'arrivalMethod', this.xuanzhongArr.arrivalMethod)
      this.$set(this.xzFormData, 'inExternalNo', this.xuanzhongArr.inExternalNo)
      // this.xzFormData.instockPlateNumber = this.xuanzhongArr.instockPlateNumber
      // this.xzFormData.driverName = this.xuanzhongArr.driverName
      // this.xzFormData.telephone = this.xuanzhongArr.telephone
      // this.xzFormData.idNumber = this.xuanzhongArr.idNumber
      // this.xzFormData.primaryCustomerTaxId = this.xuanzhongArr.primaryCustomerTaxId
      // this.xzFormData.customerTaxId = this.xuanzhongArr.customerTaxId
      // this.xzFormData.productType = this.xuanzhongArr.productType
      // this.xzFormData.instockId = this.xuanzhongArr.instockId
      // this.getRelationCustomerS()
    },
    xiugaidown () {
      this.showSave = false
      this.addHuowuVisible = true
      this.initaddHw()
      this.addHwLoading = false
      this.saveaddHwLoading = false
      if (this.xuanzhongArr.productType == '4') {
        this.xzTitle = '修改货物(螺纹钢)'
        this.showLwg = true
      } else if (this.xuanzhongArr.productType == '5' || this.xuanzhongArr.productType == '6') {
        this.xzTitle = '修改货物(盘螺、高线)'
        this.showLwg = false
      }
      this.hwFormData.instockId = this.xuanzhongArr.instockId
      this.hwFormData.instockSummaryId = this.xuanzhongArrXQ.instockSummaryId
      // this.selectObj.productType = this.xuanzhongArr.productType
      this.hwFormData.steelMillName = this.xuanzhongArr.steelMillName
      this.hwFormData.placeOfOrigin = this.xuanzhongArr.steelMillName
      this.getVirtualBalingLists()
    },
    shanchu () {
      if (this.tableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      const that = this
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteThreadMaster({
          instockIds: this.xuanzhongArr.instockId
        })
          .then(res => {
            DonMessage.success('删除成功')
            that.getThreadMasterLists()
          })
          .catch(error => {
            DonMessage.error(error.message)
          })
        // this.saveFn()
      })
    },
    chaxun () {
      this.getThreadMasterLists()
    },
    chongzhi () {
      this.formData.instockPlateNumber = ''
      this.formData.primaryCustomerTaxId = ''
      this.formData.customerTaxId = ''
      this.formData.createTimeStart = ''
      this.formData.createTimeEnd = ''
      this.formData.productType = ''
      this.formData.driverName = ''
      this.formData.arrivalMethod = ''
      this.formData.ownerCustomerTaxId = ''
      this.formData.inExternalNo = ''
      this.formData.damageflag = ''
      this.getThreadMasterLists()
    },
    dayin () {
      console.log(this.xuanzhongArr)
      if (this.tableData.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        })
        return
      }
      this.$router.push({
        path: '/xiecheDanPrint',
        query: {
          id: this.xuanzhongArr.instockId
        }
      })
    },

    // xgJz(){},
    // addJz() {
    //   this.addJingzhongVisible = true;
    // },
    queren () {
      if (this.tableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      this.querenrukuVisible = true
      this.querenLoading = false

      this.querenRukuForm.plateNumber = ''
      this.querenRukuForm.xiecheCost = ''
      this.$nextTick(() => {
        this.$refs.querenrukuFormData.clearValidate()
      })
      this.querenRukuForm.plateNumber = this.xuanzhongArr.instockPlateNumber
      // this.$confirm('是否确认入库', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // })
      //   .then((res) => {
      //     console.log(res)
      //     confirmThreadStorage({
      //       instockId: this.xuanzhongArr.instockId
      //     })
      //       .then(res => {
      //         DonMessage.success('操作成功!')
      //         this.getThreadMasterLists()
      //       })
      //       .catch(error => {
      //         DonMessage.error(error)
      //       })
      //   })
      //   .catch(() => {})
    },
    xcNumberInput () {
      this.xcFormData.weight = (this.xuanzhongArrXQ.singletonWeight / 1 * this.xcFormData.number).toFixed(3)
    },
    xc () {
      if (this.detailsData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArrXQ == null) {
        DonMessage.error('暂无货物信息')
        return
      }
      this.xcFormData = { ...this.xuanzhongArrXQ }

      this.xiecheVisible = true
      this.xcLoading = false

      this.disLocation = true
      this.disBin = true
      // this.qwData = []
      this.hwData = []
      this.$nextTick(() => {
        this.$refs.xcFormData.clearValidate()
      })
      this.zidianKuweiS()
      this.zidianQuweiS(this.xuanzhongArrXQ.warehouseId)
      this.getUsersByTenantCodes()
      this.getWeighingMethodLists(this.xuanzhongArrXQ.productType)
    },

    handleSelectionChange () { },
    selectXiangqingTable () { },
    selectAll () { },
    handleCurrentChangeXQ (val) {
      this.pageInfoXQ.pageNo = val
      this.getThreadSummaryLists()
    },
    handleSizeChangeXQ (val) {
      this.pageInfoXQ.pageSize = val
      this.getThreadSummaryLists()
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.getThreadMasterLists(this.pageInfo)
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.getThreadMasterLists(this.pageInfo)
    },
    // 添加净重dialog
    addJzDialog () {
      this.$refs.addFormData.validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeaddJz () {
      this.addJingzhongVisible = false
    },
    addXcDialog () {
      let that = this
      that.$refs.xcFormData.validate((valid) => {
        if (valid) {
          that.xcLoading = true
          that.xcFormData.instockId = that.xuanzhongArrXQ.instockId
          that.xcFormData.instockSummaryId = that.xuanzhongArrXQ.instockSummaryId
          // that.xcFormData.allWeight = that.xuanzhongArrXQ.weight
          that.xcFormData.warehouseName = that.ckData.filter(item => item.warehouseId == that.xcFormData
            .warehouseId)[0].warehouseName
          that.xcFormData.locationName = that.qwData.filter(item => item.locationId == that.xcFormData.locationId)[0].locationName
          // that.xcFormData.binName = that.hwData.filter(item => item.binId == that.xcFormData.binId)[0].binName
          that.xcFormData.sceneUser = that.ryData.filter(item => item.userCode == that.xcFormData.sceneUserId)[0]
            .userName
          if (that.inWeighingMethod == 1) {
            that.xcFormData.allWeight = that.xcFormData.weight
          } else if (that.inWeighingMethod == 2) {
            that.xcFormData.allWeight = that.xcFormData.weighingWeight
          } else if (that.inWeighingMethod == 3) {
            that.xcFormData.allWeight = that.xuanzhongArrXQ.factoryWeight
          }
          that.xcFormData.weighingDate = new Date().getTime()

          that.addOrUpdateThreadProducts(that.xcFormData)
          setTimeout(() => {
            that.xiecheVisible = false
          }, 0)
        } else {
          that.xcLoading = false
          return false
        }
      })
    },
    closeaddXc () {
      this.xiecheVisible = false
    },
    // 点击选择司机
    selectDriverChange () {
      // this.sijiChange = true
      this.table = true
    },
    selectDriver (row) {
      console.log(row)
      this.$set(this.xzFormData, 'driverName', row.name)
      this.$set(this.xzFormData, 'telephone', row.mobile)
      this.$set(this.xzFormData, 'idNumber', row.identityNo)
    },
    addHwDialog () {
      this.$refs.hwFormData.validate((valid) => {
        if (valid) {
          this.addHwLoading = true
          if (this.inWeighingMethod == 1) {
            this.hwFormData.allWeight = this.hwFormData.weight
          } else if (this.inWeighingMethod == 3) {
            this.hwFormData.allWeight = this.hwFormData.factoryWeight
          } else if (this.inWeighingMethod == 2) {
            this.hwFormData.allWeight = '0'
          }
          // this.hwFormData.allWeight = this.hwFormData.weight
          this.hwFormData.productTypeName = this.HwTypeData.filter(item => item.item_no == this.hwFormData
            .productType)[0].show_name
          this.hwFormData.placeOfOrigin = this.hwFormData.steelMillName
          // console.log(this.hwFormData)
          this.addOrUpdateThreadProducts(this.hwFormData)
          this.addHuowuVisible = false
        } else {
          this.addHwLoading = false

          return false
        }
      })
    },
    closeaddHw () {
      this.addHuowuVisible = false
      this.initaddHw()
    },
    initaddHw () {
      console.log('init')
      this.selectObj.productType = ''
      this.selectObj.steelMillName = ''
      this.selectObj.placeOfOrigin = ''
      this.selectObj.specification = ''
      this.selectObj.model = ''
      // this.selectObj.length = ''
      this.disChandi = true
      this.disGuige = true
      this.disCaizhi = true
      this.dislength = true
      this.disDanzhi = true
      this.disJianshu = true
      this.hwFormData.productType = ''
      this.hwFormData.steelMillName = ''
      this.hwFormData.placeOfOrigin = ''
      this.hwFormData.model = ''
      this.hwFormData.specification = ''
      // this.hwFormData.length = ''
      // this.hwFormData.root = ''
      this.hwFormData.singletonWeight = ''
      this.hwFormData.number = ''
      this.hwFormData.weight = ''
      this.hwFormData.factoryWeight = ''
    },
    saveaddHwDialog () {
      this.$refs.hwFormData.validate((valid) => {
        if (valid) {
          this.saveaddHwLoading = true
          console.log(this.hwFormData)
          // this.hwFormData.allWeight = this.hwFormData.weight
          if (this.inWeighingMethod == 1) {
            this.hwFormData.allWeight = this.hwFormData.weight
          } else if (this.inWeighingMethod == 3) {
            this.hwFormData.allWeight = this.hwFormData.factoryWeight
          } else if (this.inWeighingMethod == 2) {
            this.hwFormData.allWeight = '0'
          }
          this.hwFormData.placeOfOrigin = this.hwFormData.steelMillName

          this.hwFormData.productTypeName = this.HwTypeData.filter(item => item.item_no == this.hwFormData
            .productType)[0].show_name

          this.addOrUpdateThreadProducts(this.hwFormData)
          this.initaddHw()
          this.getVirtualBalingLists()
        } else {
          this.saveaddHwLoading = false
          return false
        }
      })
    },
    // 清空
    initForm () {
      this.$set(this, 'xzFormData', {})
    },
    // 新增确定按钮
    addXzDialog () {
      this.$refs.xzFormData.validate((valid) => {
        if (valid) {
          this.JZLoading = true
          this.addOrUpdateThreadMasters()
        } else {
          this.JZLoading = false
          console.log('error submit!')
          return false
        }
      })
    },
    // 新增取消按钮
    closeXz () {
      this.addRKVisible = false
      this.$set(this, 'xzFormData', {})
    },
    // 主列表显示
    getThreadMasterLists () {
      getThreadMasterList({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        instockPlateNumber: this.formData.instockPlateNumber,
        primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
        customerTaxId: this.formData.customerTaxId,
        createTimeStart: this.formData.createTimeStart,
        createTimeEnd: this.formData.createTimeEnd,
        productType: this.formData.productType,
        driverName: this.formData.driverName,
        arrivalMethod: this.formData.arrivalMethod,
        inExternalNo: this.formData.inExternalNo,
        instockStatus: 0,
        ownerCustomerTaxId: this.formData.ownerCustomerTaxId,
        damageflag: this.formData.damageflag
      })
        .then(res => {
          this.tableData = res.list
          if (res.list.length) {
            this.xuanzhongArr = res.list[0]
            this.$nextTick(() => {
              this.$refs.tabref1.setCurrentRow(res.list[0])
            })
            this.getThreadSummaryLists()
            // this.getThreadSummaryTotalWNs()
          } else {
            this.detailsData = []
            this.totalAllWeight = 0
            this.totalNumber = 0
            this.totalXQ = 0
          }
          this.querenFlag == 0
          this.total = res.total
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 新增或修改
    addOrUpdateThreadMasters () {
      this.xzFormData.ownerCustomerName = ''
      this.xzFormData.primaryCustomerName = this.xzData.filter(item => item.taxpayerNumber == this.xzFormData
        .primaryCustomerTaxId)[0].custerName
      this.xzFormData.customerName = this.xzData.filter(item => item.taxpayerNumber == this.xzFormData.customerTaxId)[
        0].custerName
      // this.xzFormData.ownerCustomerName = this.xzData.filter(item => item.taxpayerNumber == this.xzFormData.ownerCustomerTaxId)[0].custerName
      this.xzData.forEach((item, index) => {
        if (item.taxpayerNumber == this.xzFormData.ownerCustomerTaxId) {
          this.xzFormData.ownerCustomerName = item.custerName
        }
        // else {
        //   this.xzFormData.ownerCustomerName = ''
        // }
      })
      addOrUpdateThreadMaster({ ...this.xzFormData, instockStatus: '0' })
        .then(res => {
          this.addRKVisible = false
          DonMessage.success(this.messages)
          this.getThreadMasterLists()
          // this.initForm()
        })
        .catch(error => {
          this.JZLoading = false
          DonMessage.error(error.message)
        })
    },
    // 货物详情
    getThreadSummaryLists () {
      getThreadSummaryList({
        instockId: this.xuanzhongArr.instockId,
        ...this.pageInfoXQ
      })
        .then(res => {
          console.log(res)
          this.detailsData = res.list
          this.totalXQ = res.total
          this.xuanzhongArrXQ = res.list[0]
          this.getThreadSummaryTotalWNs()
          this.$nextTick(() => {
            this.$refs.tabref.setCurrentRow(res.list[0])
          })
        })
        .catch(error => {
          console.log(error)
          DonMessage.error(error.message)
        })
    },
    //
    addOrUpdateThreadProducts (params) {
      addOrUpdateThreadProduct({
        ...params
      })
        .then(res => {
          DonMessage.success('操作成功!')

          this.saveaddHwLoading = false

          this.initaddHw()
          this.getThreadSummaryLists()
          // this.getVirtualBalingLists()
        })
        .catch(error => {
          this.addHwLoading = false
          this.saveaddHwLoading = false
          this.xcLoading = true

          DonMessage.error(error.message)
        })
    },
    shanchuXQ () {
      if (this.xuanzhongArrXQ == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      const that = this
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteThreadProduct({
          instockSummaryIds: this.xuanzhongArrXQ.instockSummaryId
        })
          .then(res => {
            DonMessage.success('删除成功')
            that.getThreadSummaryLists()
          })
          .catch(error => {
            DonMessage.error(error.message)
          })
      })
    },
    dianjixuanzhongXQ (row) {
      this.xuanzhongArrXQ = {}
      this.xuanzhongArrXQ = row
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          this.RKData = res
          this.xzData = res
          this.HQData = JSON.parse(JSON.stringify(res))
          this.HQData.unshift({
            'custerName': '无货权方',
            'taxpayerNumber': '-1'
          })
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    selectWarehouse () {
      this.disLocation = false
      this.$set(this.xcFormData, 'locationId', '')
      this.$set(this.xcFormData, 'locationName', '')

      this.zidianQuweiS(this.xcFormData.warehouseId)
    },
    selectLocation () {
      // this.disBin = false
      // this.zidianHuoweiS(this.xcFormData.locationId)
    },
    // 字典--库位
    zidianKuweiS () {
      zidianKuwei({})
        .then((res) => {
          this.ckData = res
          // zidianQuwei({
          // })
          //   .then((res) => {
          //     this.qwData = res

          //   })
          //   .catch((err) => {
          //     this.$message({
          //       message: err.message,
          //       type: 'error'
          //     })
          //   })
        })
        .catch((err) => {
          // console.log(err);
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    // 字典--区位
    zidianQuweiS (warehouseId) {
      zidianQuwei({
        warehouseId
      })
        .then((res) => {
          // console.log(res)
          this.qwData = res
          // if (this.qwData.length !== 0) {
          //   this.xcFormData.locationId = this.qwData[0].locationId
          //   this.xcFormData.locationName = this.qwData[0].locationName
          //   this.zidianHuoweiS(this.xcFormData.locationId)
          // }
          // this.zidianHuoweiS();
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    // 字典--货位
    zidianHuoweiS (locationid) {
      zidianHuowei({
        locationid
      })
        .then((res) => {
          this.hwData = res
          //  {binName: "1上", binId: 23165, locationId: 1015}
          if (this.hwData.length !== 0) {
            this.xcFormData.binId = this.hwData[0].binId
            this.xcFormData.binName = this.hwData[0].binName
          } else {

          }
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    // 现场人员
    getUsersByTenantCodes () {
      getUsersByTenantCode()
        .then(res => {
          // console.log(res)
          this.ryData = res
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型
    zidians () {
      zidian({
        groupNo: 'thread_product_type'
      })
        .then((res) => {
          // console.log(res)
          this.HwTypeData = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取货物计重方式
    getWeighingMethodLists (productType) {
      getWeighingMethodList({
        productType
      })
        .then(res => {
          console.log(res)
          if (res.length > 0) this.inWeighingMethod = res[0].inWeighingMethod
          if (res[0].inWeighingMethod == 2) {
            this.xiecheRules.weighingWeight[0].required = true
            this.xiecheRules.weighingDate[0].required = true
          } else {
            this.xiecheRules.weighingWeight[0].required = false
            this.xiecheRules.weighingDate[0].required = false
          }
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    // getDictionaryLists () {
    //   getDictionaryList({ tenantCode: window.localStorage.getItem('tenantCode'), groupNo: 'in_empty_remark' })
    //     .then(res => {
    //       console.log(res)
    //       this.xzFormData.ext1 = res[0].remark
    //     })
    //     .catch(err => {
    //       this.message({ message: err.message, type: 'error' })
    //     })
    // },
    dayin1 () {
      if (this.tableData.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        })
        return
      }
      this.$router.push({
        path: '/xiecheDanPrint1',
        query: {
          id: this.xuanzhongArr.instockId
        }
      })
    },
    querenZhongYuan1 () {
      if (this.tableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }

      this.$confirm('是否确认入库', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then((res) => {
          console.log(res)
          confirmThreadCw({
            instockId: this.xuanzhongArr.instockId
          })
            .then(res => {
              DonMessage.success('操作成功!')
              this.getThreadMasterLists()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        })
        .catch(() => { })
    },
    queren1 () {
      if (this.tableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }

      this.$confirm('是否确认入库', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then((res) => {
          console.log(res)
          confirmThreadStorage({
            instockId: this.xuanzhongArr.instockId
          })
            .then(res => {
              DonMessage.success('操作成功!')
              this.getThreadMasterLists()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        })
        .catch(() => { })
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/RkInstruct')
    this.getRelationCustomerS()
    this.getThreadMasterLists()
    this.zidians()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let h2 = this.$refs.searchBox2.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = 0.6 * pH - h - 195 + 'px'
    this.detailsH = 0.4 * pH - h2 - 100 + 'px'
  }
}

</script>

<style lang="less" scoped>
.inpBox {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}

.ruKuZuoyeWarp {
  width: 100%;
  position: relative;
}

.redColor {
  color: red;
}
    /deep/.el-tabs__header{
  margin-bottom: 0;
}

  .formBox /deep/ .el-form-item{
  margin-bottom: -6px!important;
}
.detailsTitle{
  margin-bottom: 0;
}
// .formItemBox{
//     /deep/.el-form-item{
//       width: 24%;
//     }
//   }

</style>
